export default __webpack_public_path__ + "static/media/faceid.4b7bcc03.svg";